import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import {
    useAPIQuery,
    useGlobalAPIQueryContext,
} from "@dev2_techwalnut/tw-api-query-hook";
import secureLocalStorage from "react-secure-storage";

const EditPrivilege = () => {
    const userID = secureLocalStorage.getItem("userID");
    const navigate = useNavigate();
    const location = useLocation();

    const { invalidateApi } = useGlobalAPIQueryContext();

    console.log(location);
    // react Hook form Props
    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        reset,
    } = useForm();

    const { useUpdate } = useAPIQuery({
        key: "api/privileges",
        endpoint: "/api/privileges/",
    });

    const handleUpdatePrivilege = (data) => {
        Swal.fire({
            title: "Privilege Updated!",
            text: data.message,
            icon: "success",
        }).then((result) => {
            if (result.isConfirmed) {
                invalidateApi({ key: "api/roles" });
                setTimeout(() => {
                    navigate(-1);
                }, 2000);
            }
        });
    };

    const handleErrorPrivilege = (data) => {
        Swal.fire({
            title: "Error Updating Privilege",
            text: data?.data?.data?.message,
            icon: "error",
        });
    };

    const { mutate, isPending } = useUpdate({
        onSuccess: handleUpdatePrivilege,
        onError: handleErrorPrivilege,
        retry: 2,
    });

    // onSubmit handler to post form details
    const onSubmit = (data) => {
        var privilege = {
            privilege_name: data.privilege_name,
            privilege_value: data.privilege_value,
            description: data.description,
            updated_by: userID,
        };

        mutate({
            id: location.state.editpost.id,
            data: privilege,
        });
    };

    // Pre Population of Particular Product details
    useEffect(() => {
        const editPrivilege = location.state.editpost;
        // defaultValues is a react form hook.
        if (editPrivilege) {
            var defaultValues = {};
            defaultValues.privilege_name = editPrivilege.privilege_name;
            defaultValues.privilege_value = editPrivilege.privilege_value;
            defaultValues.description = editPrivilege.description;

            reset(defaultValues);
        }
    }, []);

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title"> Edit Privilege </h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-inner">
                        {/* For Form : Use React hook forms */}
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            autoComplete="off"
                        >
                            <div className="row g-4">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Privilege Display Name
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter privilege display name"
                                        id="text-forms-privilege_name"
                                        {...register("privilege_name", {
                                            required: true,
                                        })}
                                    />
                                    {errors.privilege_name && (
                                        <span className="fs-8 text-danger">
                                            Privilege Display Name is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Privilege Name
                                    </label>
                                    <input
                                        type="text"
                                        disabled
                                        className="form-control"
                                        placeholder="Enter privilege name"
                                        id="email-forms-privilege_value"
                                        {...register("privilege_value")}
                                    />
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Description
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <textarea
                                        className="form-control"
                                        placeholder="Enter description for privilege"
                                        id="textarea-forms-description"
                                        {...register("description", {
                                            required: true,
                                        })}
                                    />
                                    {errors.description && (
                                        <span className="fs-8 text-danger">
                                            Description is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="btn btn-md btn-light me-2"
                                            id="submit-button-backbutton"
                                            onClick={() => navigate(-1)}
                                        >
                                            Back
                                        </button>
                                        {isPending ? (
                                            <button
                                                type="button"
                                                id="button-privilege-loading"
                                                className="btn btn-md text-dark"
                                                disabled
                                            >
                                                Loading...
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                className="btn btn-md btn-primary"
                                                id="submit-button-update-privilege"
                                            >
                                                Update
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditPrivilege;
